// React
import React, { Component } from 'react';
import {ButtonGroup, Tooltip} from '@material-ui/core/';
import {functions} from 'constants/index';
import {Assignment, CheckCircleOutline, Block} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import BotonElement from 'components/BotonTable'; 
import Footer from 'pages/Home/Footer2';
import LoadingSpinner from 'components/LoadingSpinner';
import CustomToolTip from 'components/tooltip/';
import {showMessageErrorSimple, showMessageError} from 'services/SweetAlert'

class SolicitudesTSEVirtual extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            header: [
                { title: 'Registro No.', field: 'id',cellStyle:{ maxWidth: '80px' } },
                { title: 'Número Solicitud', field: 'idSolicitud', cellStyle:{ maxWidth: '100px' }},
                { title: 'Método de Contacto', field: 'nombreDeMetodoDeContacto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Forma de Contacto', field: 'formaDeContacto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Fecha', field: 'fechaRegistro', render: (rowData) => functions.splitDate(rowData.fechaRegistro)},
                // { title: 'Fecha', field: 'fechaRegistro'},
                // { title: 'Hora', field: 'horaRegistro' },
                { title: 'Observación', field: 'observaciones' },
                { title: 'Estado de Respuesta', field: 'nombreDeEstadoDeRespuesta'},
            ],
        }               
    }
    render() {
        return (
            <div>
                {window.screen.width >= 1024 ? (
                    <Table  
                        pageSize={this.state.pageSize} 
                        // service={ApiServices[this.state.controller]}
                        title={"Listado de Registros de contacto"}
                        header = {this.state.header}                             
                        refreshList={this.props.showList}
                        detailPanel={this.state.detailPanel}
                        data={this.props.listarDatosTabla} 
                    />
                ) : ("") }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesTSEVirtual);